webpackJsonp([52],{

/***/ "Mu6H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-total-price_27e5163b1251376e38599daf42614629.html";

/***/ }),

/***/ "ZKt+":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionTotalPrice = (function () {
    function SubscriptionTotalPrice() {
    }
    return SubscriptionTotalPrice;
}());
angular.module('animatronApp.SubscriptionTotalPrice', [])
    .component('subscriptionTotalPrice', {
    bindings: {
        totalPrice: '<'
    },
    controller: SubscriptionTotalPrice,
    templateUrl: __webpack_require__("Mu6H")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/52-40ecf89b893baa28ab63.min.js